import "./HeaderOfPages.css"

const HeaderOfPages = (props) => {
return (
    <div className="headerOfPages">
            <img 
                src={props.contImg} 
                alt={props.altImg} 
                className={"contentImg"} 
            />
            <div className="lierEffectImg"></div>
            <div className="img-content" 
            data-aos={"fade-up"}
            data-aos-duration="600"
            >
                <h1 className='content-title'>
                    {props.title}
                    <font color="red"> {props.impWord} </font>.
                </h1>
            </div>
        </div>
    )
}

export default HeaderOfPages